<template>
    <span class="inline-flex mx-1">
        <template v-for="(color, idx_color) in options.colors">
            <span
                class="q10__dot"
                :class="[color]"
                :key="idx_color"
                :style="{
                    backgroundColor: `${color}`,
                }"
            >
            </span>
        </template>
    </span>
</template>

<script>
export default {
    name: "Dots",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.q10__dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin: 3px;
}
</style>
